export default __webpack_public_path__ + "static/media/yt.597e031d.svg";